import React, { useEffect } from "react";
import HeaderImg from "../components/HeaderImg";
import AboutUs from "../components/AboutUs";
// import hero1 from "../assets/images/hero/1.jpeg";
import hero2 from "../assets/images/hero/2.jpeg";
import hero3 from "../assets/images/hero/3.jpeg";
// import hero4 from "../assets/images/hero/4.jpeg";
import hero5 from "../assets/images/hero/5.jpeg";
import hero6 from "../assets/images/hero/6.jpeg";
import hero7 from "../assets/images/hero/7.jpeg";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stats = [
    {
      name: "No. of happy customers",
      no: "50",
      plus: true,
    },
    {
      name: "No. of product sold",
      no: "300",
      plus: true,
    },
    {
      name: "Year of inception",
      no: "2024",
    },
    {
      name: "No. of Staff",
      no: "30",
      plus: true,
    },
  ];
  return (
    <div className="about">
      <HeaderImg title="About Us" />
      <div className="about__main ">
        <AboutUs aboutPage={true} />
        <div className="about__main__stats">
          {stats?.map((item) => {
            return (
              <div key={item?.no} className="about__main__stats__item">
                <p>{item?.name}</p>
                <span>
                  {item.no}
                  {item?.plus && "+"}
                </span>
              </div>
            );
          })}
        </div>
        <section style={{ background: "#f4f4f4" }} className="aboutUs alt">
          <div className="aboutUs__main alt">
            <div className="aboutUs__right">
              <h2
                className="featured__header__main"
                style={{ marginBottom: 10 }}
              >
                Our mission
              </h2>

              <p>
                To lead medical and surgical equipment sales, installation,
                fabrication to provide access to practical, technical and
                special needs solutions in Nigeria
              </p>
              <h2
                style={{ marginBottom: 10, marginTop: 40 }}
                className="featured__header__main"
              >
                Our vision
              </h2>

              <p>
                To be a world-class medical, surgical equipment and special
                education industry for the promotion of technical services and
                special needs solution
              </p>
            </div>

            <div className="aboutUs__left alt2">
              <div className="aboutUs__left__mainf alt2"></div>
              <span></span>
              {/* <img src={aboutImg} alt="" /> */}
            </div>
          </div>
        </section>

        <section className="about__main__gallery">
          <img src={hero7} alt="" />
          <img src={hero2} alt="" />
          <img src={hero3} alt="" />
          <img src={hero6} alt="" />
          <img src={hero5} alt="" />
          {/* <img src={hero2} alt="" /> */}
          {/* <img src={hero3} alt="" />
                    <img src={hero1} alt="" /> */}
        </section>
      </div>
    </div>
  );
};

export default About;
